// extracted by mini-css-extract-plugin
export var errorIcon = "_p2-1";
export var nameLogo = "_p2-0";